import del from './delete';
import get from './get';
import put from './put';

export default { get, del, put };
